export class Queue {
  constructor() {
    this.queue = [];
    this.running = false;
  }

  async enqueue(func, ...args) {
    this.queue.push({ func, args });
    if (!this.running) {
      await this.processQueue();
    }
  }

  async processQueue() {
    this.running = true;
    while (this.queue.length > 0) {
      const { func, args } = this.queue.shift();
      await func(...args);
    }
    this.running = false;
  }
}
